import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchLeads, LOGO_URL } from "../lib/api";
import { Loader2, ArrowLeft, Mail, Building2 } from "lucide-react";

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeads()
      .then(setLeads)
      .catch(() => setLeads([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-6xl px-5 py-10 md:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Content Lab" className="h-9 w-auto object-contain" />
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Lead Console</span>
          </div>
          <Link to="/" data-testid="admin-back" className="flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] text-obsidian">
            <ArrowLeft className="h-4 w-4" /> Site
          </Link>
        </div>

        <div className="mt-8 flex items-baseline gap-3">
          <h1 className="font-display text-4xl font-extrabold text-obsidian">Leads</h1>
          <span data-testid="admin-count" className="rounded-full bg-lab-light px-3 py-1 font-mono text-xs text-lab-deep">{leads.length} total</span>
        </div>

        {loading ? (
          <div className="mt-20 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-blue-brand" /></div>
        ) : leads.length === 0 ? (
          <p data-testid="admin-empty" className="mt-16 text-center text-slate-500">No leads yet. They&apos;ll appear here the moment someone requests an audit.</p>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
            {leads.map((l) => (
              <div key={l.id} data-testid="admin-lead" className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-display text-xl font-bold text-obsidian">{l.name}</p>
                    <p className="mt-1 flex items-center gap-2 text-sm text-slate-500"><Mail className="h-3.5 w-3.5" /> {l.email}</p>
                  </div>
                  {l.service && <span className="rounded-full bg-blue-light px-3 py-1 font-mono text-[10px] uppercase tracking-[0.1em] text-blue-deep">{l.service}</span>}
                </div>
                {(l.practice || l.specialty) && (
                  <p className="mt-3 flex items-center gap-2 text-sm text-slate-600"><Building2 className="h-3.5 w-3.5" /> {[l.practice, l.specialty].filter(Boolean).join(" · ")}</p>
                )}
                {l.message && <p className="mt-3 rounded-xl bg-slate-50 p-3 text-sm text-slate-600">{l.message}</p>}
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">{new Date(l.created_at).toLocaleString()}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
